import type { FC } from 'react';
import React from 'react';

import type { BaseComponentProps } from '../../types';

type ForDevice = (
  MobileComponent: FC<BaseComponentProps>,
  DesktopComponent: FC<BaseComponentProps>,
) => FC<BaseComponentProps>;

const forDevice: ForDevice = (MobileComponent, DesktopComponent) => (props) =>
  props.isMobile ? (
    <MobileComponent {...props} />
  ) : (
    <DesktopComponent {...props} />
  );

export default forDevice;
